<template>
	<div class="sale-stock">
		<!-- 导航 -->
		<!-- <van-nav-bar
		  title="自动更新库存"
		  left-text="返回"
		  left-arrow
		  @click-left="goBack"
		/> -->
		<headerTemplate title="自动更新库存"></headerTemplate>
		<div class="sale-update">
			<h2>请设置更新频率：(建议30分钟以上,不要小于15分钟)</h2>
			<div class="sale-set-wapper">
				<van-field v-model="number" type="number" label="分钟" />
				<van-button type="info" @click="saveUpdateStock">保存</van-button>
			</div>
		</div>
	</div>
</template>

<script>
	import { updateStorage, getStorageInfo } from '../../../api/sale'
	import headerTemplate from '@/components/headerTemplate/headerTemplate'
	export default {
		name: 'SaleStock',
		components: {
			headerTemplate
		},
		data() {
			return {
				// 输入的数字
				number: ''
			}
		},
		methods: {
			// 返回上一页
			goBack() {
				this.$router.go(-1)
			},
			// 保存更新
			saveUpdateStock() {
				updateStorage(this.number).then(res => {
					alert('设置成功')
				}).catch(error => {
					// alert('设置失败')
				})
			}
		},
		created() {
			getStorageInfo().then(res => {
				this.number = res.result.configMinute
			}).catch(error => {
				// alert('获取失败')
			})
		}
	}
</script>

<style lang="scss" scoped>
	.sale-stock {
		font-size: 14px;

		.sale-update {
			h2 {
				margin: 10px;
			}

			.sale-set-wapper {
				display: flex;
			}
		}
	}

	.sale-stock   ::v-deep.van-button {
		width: 100px;
	}
</style>